import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MissionSection } from "@/components/MissionSection";
import { Features } from "@/components/Features";
import { UserPathways } from "@/components/UserPathways";
import { TrustSection } from "@/components/TrustSection";
import { CTA } from "@/components/CTA";
import { FeedbackFormSection } from "@/components/FeedbackFormSection";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Shield, ArrowRight, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <main className="min-h-screen">
      <Navbar />

      {/* Testing Phase Section - Moved to top */}
      <section
        id="testing-phase"
        className="py-16 bg-gradient-to-r from-accent/10 via-primary/5 to-accent/10 border-y border-accent/20"
        role="region"
        aria-label="Prototype testing phase"
      >
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/20 backdrop-blur-sm rounded-full text-accent-foreground font-medium">
              <MessageSquare className="w-4 h-4" aria-hidden="true" />
              <span>Prototype Testing Phase</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              We Need Your Feedback
            </h2>

            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Help us improve Second Chance Connect. Share your thoughts on usability, design, and functionality.
            </p>

            <Button
              asChild
              size="lg"
              className="text-lg px-8 py-6 shadow-[var(--shadow-card)] hover:shadow-[var(--shadow-elevated)] transition-all bg-accent text-accent-foreground hover:bg-accent/90 font-semibold"
            >
              <a href="#feedback-form">
                Share Your Feedback
                <ArrowRight className="ml-2 w-5 h-5" aria-hidden="true" />
              </a>
            </Button>
          </div>
        </div>
      </section>

      {/* Home Section */}
      <Hero />

      <MissionSection />
      
      {/* Progressive Disclosure CTA Section */}
      <section className="py-24 bg-gradient-to-br from-primary via-primary/90 to-accent/80 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,_hsl(var(--accent)/0.15),transparent_50%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_70%,_hsl(var(--primary)/0.2),transparent_60%)]" />
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full text-primary-foreground font-semibold shadow-[var(--shadow-card)] border border-white/20">
              <Shield className="w-5 h-5 text-accent" />
              <span>Your Privacy Matters</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-primary-foreground leading-tight">
              You're in Control of Your Story
            </h2>
            
            <p className="text-xl text-primary-foreground/95 max-w-2xl mx-auto leading-relaxed backdrop-blur-sm bg-white/5 rounded-2xl p-6">
              Learn how Progressive Disclosure puts you in the driver's seat, protecting your privacy 
              and ensuring you're judged on your skills first.
            </p>
            
            <Button asChild size="lg" className="text-lg px-10 py-6 shadow-[var(--shadow-elevated)] hover-scale bg-white text-primary hover:bg-white/95 font-semibold">
              <Link to="/progressive-disclosure-info">
                Learn About Progressive Disclosure
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </section>

      <Features />
      <UserPathways />
      <TrustSection />
      <CTA />

      {/* Feedback Form - Positioned before footer */}
      <FeedbackFormSection />

      <Footer />
    </main>
  );
};

export default Index;
